// Kings Athletic Club brand marks (from the Brand Identity Guide 2026).
//
// KacMark — the secondary "K♣" lockup: a serif capital K followed by a club
//   suit. Scales with font-size; color is inherited (use text-* utilities).
// KacBadge — the mark reversed out of a Brooklyn Blue rounded tile, the way
//   it appears on keyfobs and court decals. Size via the `size` class prop.
// KacWordmark — the full "Kings Athletic Club" wordmark in the display face.

export function KacMark({ className = "" }) {
  return (
    <span
      className={`font-display leading-none inline-flex items-baseline ${className}`}
      aria-label="Kings Athletic Club"
    >
      <span className="font-bold">K</span>
      <span className="text-[0.62em] ml-[0.04em]" aria-hidden="true">♣</span>
    </span>
  );
}

export function KacBadge({ className = "", size = "w-9 h-9 text-xl" }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-xl bg-brand-blue text-brand-cream shadow-sm ${size} ${className}`}
    >
      <KacMark />
    </span>
  );
}

export function KacWordmark({ className = "" }) {
  return (
    <span className={`font-display tracking-wide ${className}`}>
      Kings Athletic Club
    </span>
  );
}
